// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"d3ebe4ff","171":"c31284e5","618":"7d91717e","763":"9d8f8084"}[chunkId] + ".chunk.js";
};